import {
  useActiveAccountPreferences,
  useActiveLab,
  useActivePractice,
} from '@witmetrics/data-store';
import PracticeSidebar from './PracticeSidebar';
import LabSidebar from './LabSidebar';
import { classes } from './utils';

export default function AppSidebar() {
  const activePractice = useActivePractice();
  const activeLab = useActiveLab();
  const preferences = useActiveAccountPreferences();

  const renderContent = () => {
    const sharedProps = {
      color: preferences.buttonTextColor?.value,
      bgColor: preferences.buttonBgColor?.value,
      iconClassName: classes.icon,
    };
    if (activePractice) return <PracticeSidebar {...sharedProps} />;
    if (activeLab) return <LabSidebar {...sharedProps} />;
    return null;
  };

  return <aside className={classes.sidebar}>{renderContent()}</aside>;
}
